export const transformComboItemForProductCustomizer = (state, fullProduct, comboProduct) => {
  // TODO map option overrides, not in combo data for now
  const comboItemToCustomize = state && state.comboReducer.comboItemToCustomize
  fullProduct.prices = comboProduct ? comboProduct.prices : comboItemToCustomize.prices
  if (!fullProduct.prices.find(price => price.is_default)) {
    fullProduct.prices[0].is_default = true
  }
  return fullProduct
}